
function modifyShopBtn() {
    var sheet = new CSSStyleSheet;
    // sheet.replaceSync( `button { color: pink !important; }`);
    // const host = document.querySelector('shop-pay-wallet-button')
    // host.shadowRoot.adoptedStyleSheets.push(sheet);
}

setTimeout(() => {
    modifyShopBtn()
}, 1500)

document.addEventListener('DOMContentLoaded', function() {
    findAndHideDefaultChatOpenBtn(10)
    customChatBtnListener()
})

function customChatBtnListener() {
    const chatBtn = document.querySelectorAll('.style-2-footer-customer-wrapper .chat-btn')
    if (chatBtn.length) {
        chatBtn.forEach(btn => {
            btn.addEventListener('click', function(event) {
                event.preventDefault();
                try {
                    const shopifyChatHost = document.querySelector('inbox-online-store-chat');
                    if (shopifyChatHost && shopifyChatHost.shadowRoot) {
                    const closeBtn = shopifyChatHost.shadowRoot.querySelector(".chat-app--close-button")
                    if(closeBtn) {
                        closeBtn.click()
                    }
                    const chatToggleButton = shopifyChatHost.shadowRoot.querySelector('button.chat-toggle');
                    if (chatToggleButton) {
                        chatToggleButton.click();
                        chatToggleButton.style.display = 'none'
                    } else {
                        console.error('Shopify Inbox: Internal chat toggle button not found.');
                    }
                    } else {
                    console.error('Shopify Inbox: Chat host element not found or shadowRoot not accessible.');
                    }
                } catch (error) {
                    console.error('Error programmatically opening Shopify Inbox:', error);
                }
            });
        });
    }
}

function findAndHideDefaultChatOpenBtn(maxTries = 10) {
  let attempts = 0;

  const interval = setInterval(() => {
    try {
      attempts++;

      // Safely try to get the chat host element
      let shopifyChatHost;
      try {
        shopifyChatHost = document.querySelector('inbox-online-store-chat');
      } catch (err) {
        console.warn('Error accessing chat host:', err);
        shopifyChatHost = null;
      }

      // Agar element hi nahi mila toh skip karo
      if (!shopifyChatHost || !shopifyChatHost.shadowRoot) {
        if (attempts >= maxTries) {
          console.log(`Chat host not found after ${maxTries} attempts`);
          clearInterval(interval);
        }
        return;
      }

      // Shadow DOM me style inject karte waqt safety
      try {
        const style = document.createElement('style');
        style.innerHTML = 'button.chat-toggle { display: none !important; }';
        shopifyChatHost.shadowRoot.appendChild(style);
      } catch (err) {
        console.warn('Error injecting style in shadowRoot:', err);
      }

      // Button element safely check karo
      let element = null;
      try {
        element = shopifyChatHost.shadowRoot.querySelector('button.chat-toggle');
      } catch (err) {
        console.warn('Error querying button inside shadowRoot:', err);
      }

      if (element) {
        try {
          element.style.display = 'none';
          console.log(`✅ Element found and hidden after ${attempts} attempts`);
          clearInterval(interval);
          return true;
        } catch (err) {
          console.warn('Error hiding element:', err);
        }
      }

      // Retry limit check
      if (attempts >= maxTries) {
        console.log(`❌ Element not found after ${maxTries} attempts`);
        clearInterval(interval);
        return false;
      }
    } catch (err) {
      console.error('Unexpected error in findAndHideDefaultChatOpenBtn:', err);
      clearInterval(interval);
    }
  }, 200); // Check every 200ms
}


$(document).ready(function(){
    window.addEventListener('load', () => {
      setTimeout(() => {
        const sections = document.querySelectorAll('.funnel-page .shopify-section');

        if (!sections.length) {
          console.warn('No sections found — selector issue');
          return;
        }

        const observer = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              console.log('Viewport mein aaya:', entry.target.id);
              if(entry.target.id == 'shopify-section-template--19267616702617__funnel_question_K7GQia'){
                $('#shopify-section-template--19267616702617__funnel_question_K7GQia').addClass('active');
              }else if(entry.target.id == 'shopify-section-template--19267616702617__funnel_question_full_V7nQEe') {
                $('#shopify-section-template--19267616702617__funnel_question_full_V7nQEe').addClass('active');
              }else if(entry.target.id == 'shopify-section-template--19267616702617__funnel_page_yJ7EmP') {
                $('#shopify-section-template--19267616702617__funnel_page_yJ7EmP').addClass('active');
              }else if(entry.target.id == 'shopify-section-template--19267616702617__video_slider_product_ft6Tjt'){
                $('#shopify-section-template--19267616702617__video_slider_product_ft6Tjt').addClass('active');
              }else if(entry.target.id == 'shopify-section-template--19267616702617__funnel_question_only_title_87KnyE') {
                $('#shopify-section-template--19267616702617__funnel_question_only_title_87KnyE').addClass('active');
              }else if(entry.target.id == 'shopify-section-template--19267616702617__funnel_image_sec_LfqNrJ') {
                $('#shopify-section-template--19267616702617__funnel_image_sec_LfqNrJ').addClass('active');
              }else if(entry.target.id == 'shopify-section-template--19267616702617__funnaltitle_only_WjTbDL') {
                $('#shopify-section-template--19267616702617__funnaltitle_only_WjTbDL').addClass('active');
              }else if(entry.target.id == 'shopify-section-template--19267616702617__funnel_bakers_bctD7b') {
                $('#shopify-section-template--19267616702617__funnel_bakers_bctD7b').addClass('active');
              }else if(entry.target.id == 'shopify-section-template--19267616702617__funnel_round_rBwdYF'){
                $('#shopify-section-template--19267616702617__funnel_round_rBwdYF').addClass('active');
              }else if(entry.target.id == 'shopify-section-template--19267616702617__collapsible_content_mpjiip'){
                $('#shopify-section-template--19267616702617__collapsible_content_mpjiip').addClass('active');
              }
            }
          });
        }, {
          threshold: 0.2,
          rootMargin: '0px 0px -20% 0px'
        });

        sections.forEach(section => observer.observe(section));
      }, 300);
    });

    $('.scroll-fade-text').each(function () {
      const $el2 = $(this);
      const text2 = $el2.text().trim();
      const words2 = text2.split(' ');

      let html2 = '';
      words2.forEach(word2 => {
        html2 += `<span class="word">${word2}</span> `;
      });

      $el2.html(html2);
    });

    const $el = $('.step_main .steps');
    const $bottomInner = $('.ovenCardBelow .oven-btn');
    if (!$el.length) return;

    const elementBottom = $el.offset().top + $el.outerHeight();
    const isMobile = window.innerWidth <= 767;

    const extraOffset = isMobile ? 100 : 50;

    const elementBottomInner =  $bottomInner.offset().top + $bottomInner.outerHeight() + extraOffset;
    $(window).on('scroll', function () {
      if ($(this).scrollTop() >= 1000) {
        $('.paralaxImageBack').addClass('hide');
      } else {
        $('.paralaxImageBack').removeClass('hide');
      }

      const viewportBottom = $(window).scrollTop() + $(window).height();

      if (viewportBottom >= elementBottom) {
        $('.step_main .steps').addClass('active');
      }else {
        $('.step_main .steps').removeClass('active');
      }

      if (viewportBottom >= elementBottomInner) {
        $('.step_main .steps').addClass('fadeInMine');
      }else {
        $('.step_main .steps').removeClass('fadeInMine');
      }

      //Line animate
      const scrollTop1 = $(window).scrollTop();
      const winHeight1 = $(window).height();
      const viewportCenter1 = scrollTop1 + winHeight1 / 2;

      $('.scroll-fade-text').each(function () {

        const $text1 = $(this);
        const $words1 = $text1.find('.word');

        const elTop1 = $text1.offset().top;
        const elHeight1 = $text1.outerHeight();
        const elCenter1 = elTop1 + elHeight1 / 2;

        // ✅ START → element just enters viewport
        const start1 = elTop1 - winHeight1;

        // ✅ END → element center hits viewport center
        const end1 = elCenter1 - winHeight1 / 2;

        let baseProgress1 =
          (scrollTop1 - start1) / (end1 - start1);

        baseProgress1 = Math.max(0, Math.min(1, baseProgress1));

        const totalWords1 = $words1.length;

        $words1.each(function (i1) {

          const wordProgress1 = baseProgress1 * totalWords1 - i1;
          const clamped1 = Math.max(0, Math.min(1, wordProgress1));

          const minOpacity1 = 0.2;
          const maxOpacity1 = 1;

          const opacity1 =
            minOpacity1 + (maxOpacity1 - minOpacity1) * clamped1;

          $(this).css(
            'color',
            `rgba(200, 87, 45, ${opacity1})`
          );

        });

      });

    });

    $('body').on('click', '.step-circles .circle', function(){
      var text = $(this).text();
      $('.step-circles .circle').removeClass('active');
      $(this).addClass('active');
      $('html, body').animate({
        scrollTop: $('.badge[data-id="'+text+'"]').offset().top - 100
      }, 600);
    });

    $('body').on('click', '.quick-add-modal .content-tabs__tab', function(e){
        e.preventDefault();
        $('.quick-add-modal .content-tabs__tab').removeClass('content-tabs__tab--active');
        $('.quick-add-modal .content-tabs__content').removeClass('content-tabs__content--active');
        var getId = $(this).attr('data-content-tab-id');
        $('.quick-add-modal .content-tabs__tab[data-content-tab-id="'+getId+'"]').addClass('content-tabs__tab--active');
        $('.quick-add-modal .content-tabs__content[data-content-tab-id="'+getId+'"]').addClass('content-tabs__content--active');
    });

    $('body').on('click', '.drawer__header-close', function(){
      $('body').removeClass('overflow-hidden');
    });

    $('body').on('click', '.variantImageSlider .swiper-slide', function(){
        var index = $(this).attr('data-index');
        if (window.mainSwiperPop && window.mainSwiperPop.slideTo) {
            window.mainSwiperPop.slideTo(index); // 3rd slide pe jump karega
        }
        $('.proImageSliderVariant').removeClass('hide');
    });

    $('body').on('click', '.popVariantClose', function(){
        $('.proImageSliderVariant').addClass('hide');
    });

    $('.video-slider .mineBtnMine').click(function(e){
        e.preventDefault();
        if($(this).hasClass('swiper-button-prev')){
            $('.products-tabs__layout .products-tabs-custom[aria-label="Previous slide"]').click();
            if($('.products-tabs__layout .products-tabs-custom[aria-label="Previous slide"]').hasClass('swiper-button-disabled')){
                $(this).addClass('disableMine');
            }else{
                $(this).removeClass('disableMine');
            }
            if($('.products-tabs__layout .products-tabs-custom[aria-label="Next slide"]').hasClass('swiper-button-disabled')){
                $('.mineBtnMine.swiper-button-next').addClass('disableMine');
            }else{
                $('.mineBtnMine.swiper-button-next').removeClass('disableMine');
            }
        }else{
            $('.products-tabs__layout .products-tabs-custom[aria-label="Next slide"]').click();
            if($('.products-tabs__layout .products-tabs-custom[aria-label="Next slide"]').hasClass('swiper-button-disabled')){
                $(this).addClass('disableMine');
            }else{
                $(this).removeClass('disableMine');
            }
            if($('.products-tabs__layout .products-tabs-custom[aria-label="Previous slide"]').hasClass('swiper-button-disabled')){
                $('.mineBtnMine.swiper-button-prev').addClass('disableMine');
            }else{
                $('.mineBtnMine.swiper-button-prev').removeClass('disableMine');
            }
        }
    });

    $('#insta-feed h2').wrapAll('<div class="instaWrapHeader"></div>');

    var widthWindow = $(window).width();

    if(widthWindow > 768){
        $('body').on('click', '.wheelPop', function(){
            window._klOnsite = window._klOnsite || [];
            window._klOnsite.push(['openForm', 'SaQKP4']);
        });
    }else{
        $('body').on('click', '.wheelPop', function(){
            window._klOnsite = window._klOnsite || [];
            window._klOnsite.push(['openForm', 'WkrmxQ']);
        });
    }
});